import React from 'react';
import { theme } from '../../../theme';
export const Info = ({ color, size }) => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: theme.fontSizes[size], height: theme.fontSizes[size], viewBox: "0 0 24 24" },
        React.createElement("g", { fill: theme.colors[color], fillRule: "evenodd", transform: "translate(3 3)" },
            React.createElement("path", { fillRule: "nonzero", d: "M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0zm0 2a7 7 0 1 0 0 14A7 7 0 0 0 9 2zm0 6a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1z" }),
            React.createElement("rect", { width: "2", height: "2", x: "8", y: "5", rx: "1" }))));
};
Info.defaultProps = {
    color: 'black',
    size: 'x3',
};
//# sourceMappingURL=index.js.map